import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { BuildThumbnail } from "../../components/SiteThumbnail";
import type { AdminBuild } from "../../lib/api/admin";
import { BuildDetails } from "./BuildDetails";
import { BuildRetentionNotice } from "./BuildRetentionNotice";

const PAGE_SIZE = 24;

export default function PreviewGallery({ builds, loading, incomplete }: {
  builds: AdminBuild[]; loading: boolean; incomplete: boolean;
}) {
  const [limit, setLimit] = useState(PAGE_SIZE);
  useEffect(() => setLimit(PAGE_SIZE), [builds]);
  if (!builds.length) return loading ? null : <div className="card">
    {incomplete ? "Previews could not be fully loaded. Refresh to try again." : "No available previews match. Check Build records for work still in progress."}
  </div>;
  return <section aria-label="Website previews" className="stack">
    <div className="admin-preview-grid">
      {builds.slice(0, limit).map(build => <article className="admin-preview-card" key={build.id}>
        <a className="admin-preview-image" href={build.previewUrl!} target="_blank" rel="noopener noreferrer" aria-label={`Preview ${build.name}`}>
          <BuildThumbnail buildId={build.id} label={build.name} state={build.status.replace(/_/g, " ")} className="site-preview-tile" />
          <span className="admin-preview-open"><ArrowUpRight size={19} aria-hidden="true" /></span>
        </a>
        <div className="admin-preview-body">
          <h2>{build.name}</h2>
          <p className="muted">{build.createdAt ? new Date(build.createdAt).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) : "Date unavailable"}</p>
          <BuildDetails build={build} />
          <div className="admin-preview-links">
            <a href={build.previewUrl!} target="_blank" rel="noopener noreferrer">Open preview <ArrowUpRight size={14} aria-hidden="true" /></a>
            {build.siteId && <Link to={`/sites/${build.siteId}`}>Manage site</Link>}
            <BuildRetentionNotice build={build} />
          </div>
        </div>
      </article>)}
    </div>
    {builds.length > limit && <button className="btn admin-preview-more" onClick={() => setLimit(value => value + PAGE_SIZE)}>Show more previews ({builds.length - limit} remaining)</button>}
  </section>;
}
